var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insert"},[_c('app-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Add section'),expression:"'Add section'"}],staticClass:"insert-icon",attrs:{"icon":"add"},nativeOn:{"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }